import { TransitOperationAuditPageResponse } from '../../../api/models'

export const isBulgarianAudit = (row: TransitOperationAuditPageResponse | null): boolean => (
  row?.auditReason?.includes('SIGNING REQUIRED') ?? false
)
